import { Number } from "../Number";
export var Restriction;
(function (Restriction) {
    function convert(restriction) {
        const { verify, condition } = getVerifier(...restriction);
        return [verify, condition];
    }
    Restriction.convert = convert;
    function restrict(type, ...restriction) {
        const { verify, condition } = getVerifier(...restriction);
        return type.restrict(verify, condition);
    }
    Restriction.restrict = restrict;
    function getVerifier(...condition) {
        const conditions = {
            length: ((verifier) => ({
                verify: (value) => verifier.verify(value.length),
                condition: "length." + verifier.condition,
            }))(Number.Restriction.getVerifier(...condition.slice(1))),
        };
        return conditions[condition[0]];
    }
    Restriction.getVerifier = getVerifier;
})(Restriction || (Restriction = {}));
//# sourceMappingURL=Restriction.js.map